import P5 from 'p5';
import fontData from 'data-url:./assets/m5x7.ttf';
import imgLollipopPath from 'data-url:./assets/lollipop.png';
import imgFingerPath from 'data-url:./assets/finger.png';
import imgSeaPath from 'data-url:./assets/sea.png';
import imgPointerPath from 'data-url:./assets/pointer.png';
import {loadFont} from '../util/loadFont';
import {loadImage} from '../util/loadImage';
import {clamp} from '../util/math';

const random = Math.random;

const frameRate = 30;
const framePadding = 10;
const textSize = 16;

const velX = 3;
const velY = 3;
const velVect = Math.sqrt(Math.pow(velX, 2) + Math.pow(velY, 2));

const word = 'Hey';

const colors = {
  background: 'black',

  frameBorder: 'white',
  frameBackground: 'transparent',

  text: 'white',
};

const getCanvasSize = () => Math.min(window.innerHeight, window.innerWidth);

// Creating the sketch itself
const sketch = (p5: P5) => {
  let canvas: P5.Renderer;
  let canvasSize: number;

  let font: P5.Font;

  let imgLollipop: P5.Image;
  let imgFinger: P5.Image;
  let imgSea: P5.Image;
  let imgPointer: P5.Image;

  let lolliW: number;
  let lolliH: number;

  let fingerW: number;
  let fingerH: number;
  const fingerOffsetX = 10;

  let pointerW: number;
  let pointerH: number;

  p5.preload = () => {
    font = loadFont(p5, fontData);
    imgLollipop = loadImage(p5, imgLollipopPath);
    imgFinger = loadImage(p5, imgFingerPath);
    imgSea = loadImage(p5, imgSeaPath);
    imgPointer = loadImage(p5, imgPointerPath);
  };

  let pixelSizeReal: number;

  let textWidth: number;
  let totalPixels: number;
  // let textHeight: number = textSize * 0.75;

  let minX: number;
  let minY: number;
  let maxX: number;
  let maxY: number;

  let targetX: number | null = null;
  let targetY: number | null = null;

  let posX: number;
  let posY: number;

  let lollipopTouched = false;

  // The sketch setup method
  p5.setup = () => {
    p5.noCursor()

    totalPixels = imgSea.width + 2 * (framePadding + 1);

    minX = framePadding + 1;
    minY = framePadding + 1;
    maxX = totalPixels - framePadding - 1;
    maxY = totalPixels - framePadding - 1;

    // Creating and positioning the canvas
    canvasSize = getCanvasSize();
    canvas = p5.createCanvas(canvasSize, canvasSize);
    pixelSizeReal = canvasSize / totalPixels;
    canvas.parent('app');

    p5.frameRate(frameRate);
    p5.textFont(font);
    p5.textSize(textSize);

    textWidth = p5.textWidth(word);

    lolliW = imgLollipop.width;
    lolliH = imgLollipop.height;

    fingerW = imgFinger.width;
    fingerH = imgFinger.height;

    pointerW = imgPointer.width;
    pointerH = imgPointer.height;

    posX = Math.floor(random() * (maxX - lolliW - minX) + minX);
    posY = Math.floor(random() * (maxY - lolliH - minY) + minY);

    window.onresize = function () {
      canvasSize = getCanvasSize();
      pixelSizeReal = canvasSize / totalPixels;
      canvas.size(canvasSize, canvasSize);
    };

    // window.setInterval(onTick, 50);
  };

  let mouseX = 0;
  let mouseY = 0;
  p5.mouseMoved = (e: MouseEvent) => {
    const {x, y} = canvas.position() as { x: number, y: number };

    const diffX = e.x - x;
    const diffY = e.y - y;

    if (diffX < 0) {
      mouseX = 0;
    } else {
      mouseX = e.x - x;
    }
    if (diffY < 0) {
      mouseY = 0;
    } else {
      mouseY = e.y - y;
    }
  };

  // let textX = Math.floor(random() * (maxX - minX) + minX);
  // let textY = Math.floor(random() * (maxY - minY) + minY);
  // let velX = 1;
  // let velY = 1;

  const onTick = (fX: number, fY: number) => {
    if (targetX != null && targetY != null) {
      posX += Math.abs(targetX - posX) < velX ? 0 : velX * (targetX - posX > 0 ? 1 : -1);
      posY += Math.abs(targetY - posY) < velY ? 0 : velY * (targetY - posY > 0 ? 1 : -1);

      const dist = Math.sqrt(Math.pow(posX - targetX, 2) + Math.pow(posY - targetY, 2));
      if (dist <= velVect) {
        posX = targetX;
        posY = targetY;

        targetX = null;
        targetY = null;
      }
    }

    // Is mouse in lollipop area?
    if (fX > posX - lolliW * 0.1 && fX <= posX + lolliW * 1.1 && fY >= posY - lolliH * 0.1 && fY <= posY + lolliH * 1.1) {

      if (targetX == null) {
        do {
          let tX = Math.floor(random() * (maxX - lolliW - minX) + minX);
          let tY = Math.floor(random() * (maxY - lolliH - minY) + minY);

          if (fX > tX && fX <= tX + lolliW && fY >= tY && fY <= tY + lolliH) {
            continue;
          }

          targetX = tX;
          targetY = tY;

          lollipopTouched = true;

          break;
        } while (true);
      }
    }
  };

  // The sketch draw method
  p5.draw = () => {
    p5.noSmooth();
    p5.scale(pixelSizeReal);

    p5.fill(colors.background);
    p5.rect(0, 0, totalPixels, totalPixels);

    p5.textSize(textSize);

    drawFrame(p5);

    p5.image(imgSea, minX, minY);

    p5.fill(colors.text);
    p5.image(imgLollipop, posX, posY);

    const mX = mouseX / pixelSizeReal;
    const mY = mouseY / pixelSizeReal;

    const fX = clamp(mX, minX, maxX) - fingerOffsetX;
    const fY = clamp(mY, minY + (maxX - fingerH), maxY - fingerH * 0.25);

    //  clamp(mX - fingerOffsetX, 0, maxX-fingerW)
    // p5.image(imgFinger, fX, fY);

    /*
            img: Image | Element,
            dx: number,
            dy: number,
            dWidth: number,
            dHeight: number,
            sx: number,
            sy: number,
            sWidth?: number,
            sHeight?: number
     */
    // Cut out the finger image if needed
    const fSX = fX < minX ? minX - fX : 0;
    const fSY = fY < minY ? minY - fY : 0;
    const fSW = fX + fingerW > maxX ? fingerW - (fX + fingerW - maxX) - fSX : fingerW - fSX;
    const fSH = fY + fingerH > maxY ? fingerH - (fY + fingerH - maxY) - fSY : fingerH - fSY;

    p5.image(
      imgFinger,
      fSX + fX, fSY + fY, fSW, fSH,
      fSX, fSY, fSW, fSH,
    );

    if (!lollipopTouched) {
      const pH = pointerH * 0.5;
      p5.image(imgPointer, framePadding + 2, totalPixels - framePadding - 2 - pH, pointerW * 0.5, pH);
    }

    onTick(fX + fingerOffsetX, fY);
  };

  const drawFrame = (p5: P5) => {
    p5.push();

    p5.noFill();
    p5.stroke(colors.frameBorder);

    p5.rect(1, 1, totalPixels - 2, totalPixels - 2);
    p5.rect(framePadding, framePadding, totalPixels - framePadding * 2, totalPixels - framePadding * 2);

    // p5.strokeWeight(1);
    // p5.stroke(colors.frameBorder);
    // p5.noFill();

    // p5.rect(0, 0, totalPixels, totalPixels);
    // p5.rect(framePadding, framePadding, totalPixels - framePadding * 2, totalPixels - framePadding * 2);

    p5.noStroke();
    p5.fill(colors.text);
    p5.text('404', framePadding, framePadding - 1);

    p5.textAlign(p5.RIGHT);
    p5.text('Not Found', totalPixels - framePadding, framePadding - 1);

    p5.text('@8bittake', totalPixels - framePadding, totalPixels - 2);
    p5.pop();
  };
};

new P5(sketch);
